import "./loan-sections.css";

const BENEFITS = [
  {
    icon: "fa-percent",
    title: "Competitive interest rates",
    text: "Best rates from top banks & NBFCs",
  },
  {
    icon: "fa-bolt",
    title: "Quick & easy approval",
    text: "Hassle-free process with minimal paperwork",
  },
  {
    icon: "fa-calendar-check",
    title: "Flexible repayment options",
    text: "EMI plans that fit your budget",
  },
  {
    icon: "fa-shield-halved",
    title: "Safe & secure",
    text: "Your data is 100% secure with us",
  },
];

export default function LoanBenefits() {
  return (
    <section className="loan-benefits">
      <div className="loan-benefits-panel">
        <header className="loan-section-head loan-section-head--left">
          <p className="loan-eyebrow">BENEFITS YOU&apos;LL LOVE</p>
          <h2>Loans That Work for You</h2>
        </header>

        <div className="loan-benefits-grid">
          <ul className="loan-benefits-list">
            {BENEFITS.map((item) => (
              <li key={item.title}>
                <span className="loan-benefits-icon" aria-hidden="true">
                  <i className={`fa-solid ${item.icon}`} />
                </span>
                <div>
                  <strong>{item.title}</strong>
                  <p>{item.text}</p>
                </div>
              </li>
            ))}
          </ul>

          <div className="loan-benefits-visual">
            <img
              src="/images/loan-benefits-approved.png"
              alt="Loan approved with competitive offers"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
